import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Link } from '@stackflow/link';
import { useTranslation } from 'react-i18next';

function SignUpText() {
    const { t } = useTranslation('signIn');
    return (
        <Container align='center'
            fullWidth
            spacing={4}>
            <Row spacing={4} fullWidth>
                <Line />
                <Text size='title' color={colors.textUnselected}>
                    {t('or')}
                </Text>
                <Line />
            </Row>
            <Link activityName='SignUpActivity'
                activityParams={{}}
                css={css`padding: var(--spacing-4)`} >
                <Text size='body-short' fontWeight='bold'>
                    {t('signUp')}
                </Text>
            </Link>
        </Container>
    );
}

const Container = styled(Column)`
    padding-top: 12px;
`;

const Line = styled.div`
    background-color: var(--color-border-disabled);
    flex: 1;
    height: 1px;
    width: 100%;
`;

export default SignUpText;
